import React from 'react';

import style from './index.module.scss';

const KimCustomersDynamicsInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Заказчики+динамика КИМ</h1>

    <div className={style.description}>
      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>
          Сервис позволяет с помощью набора фильтров посмотреть информацию по динамике опубликованных ценовых запросов
          Заказчиков в КИМ
        </div>
      </div>
    </div>
  </>
);

export default KimCustomersDynamicsInfo;
